module.exports = __webpack_public_path__ + "img/1525926729.fcf29e1c.jpg";